/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { AboutVirdioPage } from "../pages/AboutVirdio";
import { AskMyraPage } from "../pages/AskMyra";
import { HowItWorksPage } from "../pages/HowItWorks";
import SelfAssessment2 from "./SelfAssessment";
// import { LandingPage } from "../virdioHealth/LandingPage";
import { AboutUs } from "../virdioHealth/About";
import { ContactUs } from "../virdioHealth/ContactUs";
function AppRoutesInner() {
    return (
        <>
            <Switch>
                <Route path="/" exact component={SelfAssessment2} />
                <Route path="/ask-myra" component={AskMyraPage} />
                <Route path="/how-it-works" component={HowItWorksPage} />
                <Route path="/about" component={AboutVirdioPage} />
                <Route path="/about-us" component={AboutUs} />
                <Route path="/contact-us" component={ContactUs} />
            </Switch>
        </>
    );
}
export default function AppRoutesV2() {
    return (
        <Router>
            <AppRoutesInner />
        </Router>
    );
}
